import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import '../../../../styles/DashboardProspectPopup.css';
import {
    Prospect,
    sendTourSignupEmail,
    // PhoneAndEmail,
    // updatePhoneAndEmail,
    getTourInfo,
    updateApplicationStatus,
    markTourCompleted,
    getGuestCardInfo,
    toggleProspectExclusion,
} from '../../../../api/Prospect';
import Button from '../../../common/form/Button';
import { useState, useEffect } from 'react';
import { postAction } from '../../../../hooks/postAction';
import { TourStatuses } from '../../../../utilities/Enums';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../common/LoadingOverlay';
import {userIsCompanyDashboardUser, userIsPropertyDashboardUser, userIsSystemAdmin, userIsSystemDashboardUser } from '../../../../utilities/identity';
// import { ProspectInfoRowEditable } from '../../admin/dashboardWidgets/prospectInfoRowEditable';
import moment from 'moment-timezone';
import { ProspectInfoRow } from './prospectInfoRow';
import { formatPhoneNumber } from '../../../../utilities/Utils';
import * as identity from '../../../../utilities/identity';
import TourAccessInformation from '../../../common/TourAccessInformation';
import BlockProspectModal from './blockProspectPopup';

interface PopupProps {
    prospectToken: string | null;
    prospect: any | undefined;
    propertyId: number | null;
    setSelectedProspectToken: (prospectToken: string | null) => void;
}

enum RecentActivityViewType {
    ToursScheduled,
    GuestCardOnly
}

export const DashboardProspectPopup = ({
    prospectToken,
    prospect,
    propertyId,
    setSelectedProspectToken
}: PopupProps) => {

    const viewRole = (userIsCompanyDashboardUser() ||
    userIsPropertyDashboardUser() ||
    userIsSystemDashboardUser());

    const [isSending, setIsSending] = useState(false);
    const [messageSent, setMessageSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    // const [phoneAndEmailObject, setPhoneAndEmailObject] = useState<PhoneAndEmail | null>(null);
    const [prospectTemp, setProspectTemp] = useState<Prospect | undefined>(prospect);

    const [tourChangeLoading, setTourChangeLoading] = useState(false);
    // const [contactInfoChangeLoading, setContactInfoChangeLoading] = useState(false);

    const [activeTours, setActiveTours] = useState<Record<any, any>>({});
    const [activeGuestCards, setActiveGuestCards] = useState<Record<any, any>>({});
    const [openBlockProspect, setBlockProspect] = useState(false);
    const [banReason, setBanReason] = useState('');

    const [viewType, setViewType] = useState<RecentActivityViewType>(
        RecentActivityViewType.ToursScheduled
    );

    const toggleGuestCardDropdown = async (guid: number) => {

        if(activeGuestCards[guid]==null){
            setTourChangeLoading(true)
            let result = await getGuestCardInfo(guid);
            if(result.success && result.data){
              const fetchedData = result.data

              setActiveGuestCards((prevState) => ({
                    ...prevState,
                    [guid]: {
                        viewType: !(prevState[guid] != null && prevState[guid]['viewType']), // Toggle viewType safely
                        data: fetchedData,
                    },
                }));
            }
            setTourChangeLoading(false)
        }
        else{
            setActiveGuestCards((prevState) => ({
                ...prevState,
                [guid]: {
                    viewType: !(prevState[guid] != null && prevState[guid]['viewType']), // Toggle viewType safely
                    data: prevState[guid]['data']
                },
            }));
        }
    };

    const toggleDropdown = async (tourId: number) => {

        if(activeTours[tourId]==null){
            setTourChangeLoading(true);(true)
            let result = await getTourInfo(tourId);
            if(result.success && result.data){
              const fetchedData = result.data
                setActiveTours((prevState) => ({
                    ...prevState,
                    [tourId]: {
                        viewType: !(prevState[tourId] != null && prevState[tourId]['viewType']), // Toggle viewType safely
                        data: fetchedData,
                    },
                }));
            }
            setTourChangeLoading(false)
        }
        else{
            setActiveTours((prevState) => ({
                ...prevState,
                [tourId]: {
                    viewType: !(prevState[tourId] != null && prevState[tourId]['viewType']), // Toggle viewType safely
                    data: prevState[tourId]['data']
                },
            }));
        }
    };      

    let resetMessageState: () => void = () => {
        // setIsSending(false);
        // setMessageSent(false);
    };

    let fontSizeStyle = {
        fontSize: '15px'
    };

    const handleIncludeOrExcludeGuestCard = async (guestCardId: any) => {

        setTourChangeLoading(true);
        if (activeGuestCards[guestCardId]['data']['publicKey'] === undefined) {
            setErrorMessage('Prospect has no associated ID.');
            setTourChangeLoading(false);
            return;
        }

        let excludeResult = await toggleProspectExclusion(activeGuestCards[guestCardId]['data']['publicKey']);
        if (excludeResult.success) {
            activeGuestCards[guestCardId]['data']['excludeFromStatistics'] =
                !activeGuestCards[guestCardId]['data']['excludeFromStatistics']
            setErrorMessage(undefined);
        } else if (excludeResult.error) {
            setErrorMessage(excludeResult.error);
        }

        setTourChangeLoading(false);
    };

    const handleIncludeOrExclude = async (tourId: any) => {

        setTourChangeLoading(true);
        if (activeTours[tourId]['data']['tourInformation']['tourGuid'] === undefined) {
            setErrorMessage('Prospect has no associated ID.');
            setTourChangeLoading(false);
            return;
        }

        let excludeResult = await toggleProspectExclusion(activeTours[tourId]['data']['tourInformation']['tourGuid']);
        if (excludeResult.success) {
            activeTours[tourId]['data']['prospect']['excludeFromStatistics'] =
                !activeTours[tourId]['data']['prospect']['excludeFromStatistics']
            setErrorMessage(undefined);
        } else if (excludeResult.error) {
            setErrorMessage(excludeResult.error);
        }

        setTourChangeLoading(false);
    };

    const closePopup = () => {
        setSelectedProspectToken(null);
        setProspectTemp(undefined);
        setErrorMessage(undefined);
        // setPhoneAndEmailObject(null);
        setBanReason('');
    };

    useEffect(resetMessageState, [prospectToken]);

    useEffect(() => {
        if (prospectTemp === undefined && prospect !== undefined) {
            setProspectTemp(prospect);
        }
    });

    useEffect(()=>{
        if(prospect && prospect.blockedReason){
            setBanReason(prospect.blockedReason)
        } else {
            setBanReason('')
        }
    },[prospect])

    return (
        <>
        <Modal isOpen={(prospectToken !== null && !openBlockProspect)} toggle={closePopup} className="prospect-popup">
            <LoadingOverlay show={tourChangeLoading} inBootstrapColumn={false} />
            <ModalBody>
                {!prospect ? null : (
                    <>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            {banReason !== '' ? (
                                <div style={{ background: '#FEE9E7', width: '300px', padding: '16px', marginBottom: '12px', borderRadius: '4px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <p style={{ fontWeight: 'bold', margin: 0, color: "#C00F0C" }}>Blocked</p>
                                    <svg
                                    width="16"
                                    height="17"
                                    viewBox="0 0 16 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path
                                        d="M11.4688 13.4062L3.09375 5.03125C2.40625 6.03125 2 7.21875 2 8.5C2 11.8125 4.6875 14.5 8 14.5C9.28125 14.5 10.4688 14.0938 11.4688 13.4062ZM12.875 12C13.5625 11 14 9.8125 14 8.5C14 5.1875 11.3125 2.5 8 2.5C6.6875 2.5 5.5 2.9375 4.5 3.625L12.875 12ZM0 8.5C0 5.65625 1.5 3.03125 4 1.59375C6.46875 0.15625 9.5 0.15625 12 1.59375C14.4688 3.03125 16 5.65625 16 8.5C16 11.375 14.4688 14 12 15.4375C9.5 16.875 6.46875 16.875 4 15.4375C1.5 14 0 11.375 0 8.5Z"
                                        fill="#C00F0C"
                                    />
                                    </svg>
                                </div>
                                <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#555' }}>
                                    Reason: <span>{banReason}</span>
                                </p>
                                </div>
                            ) : (
                                <div></div>
                            )}
                            <div style={{ cursor: 'pointer' }} onClick={()=>{
                                closePopup()
                            }}>
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.92422 0.326953C1.48359 -0.108984 0.771094 -0.108984 0.330469 0.326953C-0.110156 0.762891 -0.105469 1.48008 0.330469 1.9207L8.90859 10.4988L0.330469 19.077C-0.110156 19.5176 -0.110156 20.2301 0.330469 20.666C0.771094 21.102 1.48359 21.1066 1.91953 20.666L10.4977 12.0879L19.0805 20.6707C19.5211 21.1113 20.2336 21.1113 20.6695 20.6707C21.1055 20.2301 21.1102 19.5176 20.6695 19.0816L12.0914 10.5035L20.6742 1.9207C21.1148 1.48008 21.1148 0.767578 20.6742 0.331641C20.2336 -0.104297 19.5211 -0.108984 19.0852 0.331641L10.507 8.90977L1.92422 0.326953Z" fill="#888888"/>
                                </svg>
                            </div>
                        </div>
                        <h5 style={{ color: '#888888', fontSize: '20px' }}>Prospect Information:</h5>
                        <h3 style={{ padding: '10px 0px' }}>
                            {prospect.firstName} {prospect.lastName}
                        </h3>
                        <p style={{ fontSize: '12px' }}>Last Updated by {prospect.lastUpdatedBy} at {moment(prospect.lastUpdatedDate).format('MM/DD/YYYY [at] h:mmA')}</p>
                        <h4 className='prospect-info-head'>Contact</h4>
                        {/* <div style={fontSizeStyle}>
                            {phoneAndEmailObject ? (
                                <div className="position-relative">
                                    <LoadingOverlay
                                        show={contactInfoChangeLoading}
                                        inBootstrapColumn={false}
                                    />
                                    <ProspectInfoRowEditable
                                        label="Email"
                                        value={phoneAndEmailObject.email}
                                        isPhoneInput={false}
                                        onChangeAction={async newValue => {
                                            setPhoneAndEmailObject({
                                                email: newValue,
                                                phoneNumber: phoneAndEmailObject.phoneNumber
                                            });
                                            setErrorMessage(undefined);
                                        }}
                                    />
                                    <ProspectInfoRowEditable
                                        label="Phone Number"
                                        value={phoneAndEmailObject.phoneNumber}
                                        isPhoneInput={true}
                                        onChangeAction={async newValue => {
                                            setPhoneAndEmailObject({
                                                email: phoneAndEmailObject.email,
                                                phoneNumber: newValue
                                            });
                                            setErrorMessage(undefined);
                                        }}
                                    />
                                  
                                    <div style={{ gap: '4px' }} className="clearfix mt-2 d-flex gap-4">
                                        <Button
                                            addlClassName="btn-primary edit-button"
                                            text="Save"
                                            onClick={async () => {
                                                if (!phoneAndEmailObject.email.includes('@')) {
                                                    setErrorMessage(
                                                        'Please enter valid email address.'
                                                    );
                                                    return;
                                                }

                                                if (prospectToken !== null) {
                                                    setContactInfoChangeLoading(true);
                                                    let result = await updatePhoneAndEmail(
                                                        prospectToken,
                                                        phoneAndEmailObject
                                                    );
                                                    let newProspect = prospect;
                                                    setContactInfoChangeLoading(false);

                                                    if (
                                                        result.success &&
                                                        result.data &&
                                                        !result.error
                                                    ) {
                                                        newProspect.contactInfo.phone =
                                                            result.data.phoneNumber;
                                                        newProspect.contactInfo.email =
                                                            result.data.email;
                                                      
                                                        setPhoneAndEmailObject(null);
                                                        setErrorMessage(undefined);
                                                    } else {
                                                        setErrorMessage(
                                                            result.error ||
                                                            'Unable to update contact info. \
                                                            Please refresh and try again.'
                                                        );
                                                    }
                                                } else {
                                                    setErrorMessage(
                                                        'Unable to update contact info. Please refresh and try again.'
                                                    );
                                                }
                                            }}
                                            disabled={viewRole}
                                        />
                                        <Button
                                            addlClassName="btn-grey edit-button"
                                            text="Cancel"
                                            onClick={async () => {
                                                setPhoneAndEmailObject(null);
                                                setErrorMessage(undefined);
                                            }}
                                            disabled={viewRole}
                                        />
                                       { identity.userIsCompanyDashboardAdmin() && <Button
                                            addlClassName="btn-danger edit-button"
                                            text="Block User"
                                            onClick={async () => {
                                                setBlockProspect(true)
                                            }}
                                            disabled={viewRole}
                                        /> }
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <ProspectInfoRow
                                        label="Email"
                                        value={prospect.email}
                                        externalLabelStyle={{ paddingLeft: '0px' }}
                                    />
                                    <ProspectInfoRow
                                        label="Phone Number"
                                        value={formatPhoneNumber(prospect.phoneNumber)}
                                        externalLabelStyle={{ paddingLeft: '0px' }}
                                    />
                                     { !prospect.blocked && <div className="clearfix mt-2">
                                        <Button
                                            addlClassName="btn-primary edit-button"
                                            text="Edit Contact Info"
                                            onClick={async () => {
                                                setPhoneAndEmailObject({
                                                    phoneNumber: prospect.phoneNumber || '',
                                                    email: prospect.email || ''
                                                });
                                            }}
                                            disabled={viewRole}
                                        /> 
                                    </div>}
                                </>
                            )}
                        </div> */}
                        <div style={fontSizeStyle}>
                            <ProspectInfoRow
                                label="Email"
                                value={prospect.email}
                                externalLabelStyle={{ paddingLeft: '0px' }}
                            />
                            <ProspectInfoRow
                                label="Phone Number"
                                value={formatPhoneNumber(prospect.phoneNumber)}
                                externalLabelStyle={{ paddingLeft: '0px' }}
                            />
                            {
                              identity.userIsCompanyDashboardAdmin() && !prospect.blocked && banReason === '' && <Button
                                    addlClassName="btn-danger edit-button"
                                    text="Block User"
                                    style={{ float: 'none' }}
                                    onClick={async () => {
                                        setBlockProspect(true)
                                    }}
                                    disabled={viewRole}
                                /> 
                            }
                        </div>

                        <div className="space-y-4">
                           <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '12px' }}>
                                <h4 className="prospect-info-head">Activity</h4>
                                <select
                                    className="dashboard-select"
                                    onChange={event => {
                                        setViewType(parseInt(event.target.value, 10));
                                    }}
                                >
                                    <option value={RecentActivityViewType.ToursScheduled}>
                                        Scheduled Tour
                                    </option>
                                    <option value={RecentActivityViewType.GuestCardOnly}>
                                        Guest Card Only
                                    </option>
                                </select>
                           </div>
                            {prospect.tours.map((tour: any) =>
                                tour.tourId !=null && viewType === RecentActivityViewType.ToursScheduled ? (
                                    <div key={tour.tourId} style={{ background: '#f6f6f6' }} className="border rounded shadow p-2 mb-2">
                                        {/* Header Section */}
                                        <div
                                            onClick={() => toggleDropdown(tour.tourId)}
                                            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', cursor: 'pointer' }}
                                        >
                                        {tour.dateAndTime !=null && <div style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
                                                <p className='container-head-text' >{tour.propertyName}</p>
                                                <p style={{ margin: '0px' }}>{moment(tour.dateAndTime).format("MM/DD/YYYY h:mm A")}</p>
                                            </div> }
                                            <span>
                                                {activeTours[tour.tourId]!=null && activeTours[tour.tourId]['viewType'] ? '▲' : '▼'}
                                            </span>
                                        </div>
                                        {/* Details Section */}
                                        {activeTours[tour.tourId]!=null &&  activeTours[tour.tourId]['viewType'] && (
                                            <div className="mt-2">
                                                <p>{activeTours[tour.tourId]['data']['tourInformation']['tourStatus']}</p>
                                                <div style={{ marginLeft: '12px' }}>
                                                {activeTours[tour.tourId]['data']['tourInformation']['tourStartDate']!=null &&
                                                   <p>
                                                     <strong className="container-lable-key">Tour Date:</strong> {activeTours[tour.tourId]['data']['tourInformation']['tourStartDate']}
                                                   </p>
                                                }
                                                {activeTours[tour.tourId]['data']['tourInformation']['tourStartTime'] !=null &&
                                                    <p>
                                                        <strong className="container-lable-key">Tour Time:</strong> {activeTours[tour.tourId]['data']['tourInformation']['tourStartTime']}
                                                    </p>    
                                                }
                                                {activeTours[tour.tourId]['data']['prospect']['tourTypeDisplay'] !=null &&
                                                    <p>
                                                        <strong className="container-lable-key">Type:</strong> {activeTours[tour.tourId]['data']['prospect']['tourTypeDisplay']}
                                                    </p>
                                                }
                                                {activeTours[tour.tourId]['data']['prospect']['partnerName'] !=null &&
                                                    <p>
                                                        <strong className="container-lable-key">Partner:</strong> {activeTours[tour.tourId]['data']['prospect']['partnerName']}
                                                    </p>
                                                }
                                                {activeTours[tour.tourId]['data']['prospect']['contactPreferenceDisplay'] !=null &&  <p>
                                                    <strong className="container-lable-key">Contact Preference:</strong> {activeTours[tour.tourId]['data']['prospect']['contactPreferenceDisplay']}
                                                </p>}
                                                <p>
                                                    <strong className="container-lable-key">Desired Move-In Date:</strong> {activeTours[tour.tourId]['data']['prospect']['moveInDate']}
                                                </p>
                                                 <p>
                                                    <strong className="container-lable-key">Pets:  </strong> {activeTours[tour.tourId]['data']['prospect']['pets'] ? 'Allowed' : 'No Pets'}
                                                </p>
                                                {activeTours[tour.tourId]['data']['prospect']['source'] !=null &&
                                                   <p>
                                                     <strong className="container-lable-key">Source:  </strong> {activeTours[tour.tourId]['data']['prospect']['source']}
                                                   </p>
                                                }
                                                {activeTours[tour.tourId]['data']['prospect']['desiredLeaseLength'] !=null &&
                                                    <p>
                                                        <strong className="container-lable-key">Desired Lease Length:</strong> {activeTours[tour.tourId]['data']['prospect']['desiredLeaseLength']}
                                                    </p>    
                                                }
                                                {activeTours[tour.tourId]['data']['tourInformation']['idCheckStatus'] !=null &&
                                                    <p>
                                                        <strong className="container-lable-key">ID Check Status:</strong> {activeTours[tour.tourId]['data']['tourInformation']['idCheckStatus']}
                                                        {activeTours[tour.tourId]['data']['tourInformation']['idCheckStatus'] === "Failed" && 
                                                            <div className="tooltip-container">
                                                                <svg style={{ verticalAlign: 'middle', marginLeft: '6px' }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M6.07692 5.65385H6.5V9.46154H6.92308M12 6.5C12 7.95869 11.4205 9.35764 10.3891 10.3891C9.35764 11.4205 7.95869 12 6.5 12C5.04131 12 3.64236 11.4205 2.61091 10.3891C1.57946 9.35764 1 7.95869 1 6.5C1 5.04131 1.57946 3.64236 2.61091 2.61091C3.64236 1.57946 5.04131 1 6.5 1C7.95869 1 9.35764 1.57946 10.3891 2.61091C11.4205 3.64236 12 5.04131 12 6.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                                    <path d="M6.92306 3.74974C6.92306 3.86194 6.87848 3.96956 6.79914 4.0489C6.7198 4.12824 6.61219 4.17281 6.49998 4.17281C6.38777 4.17281 6.28016 4.12824 6.20082 4.0489C6.12148 3.96956 6.0769 3.86194 6.0769 3.74974C6.0769 3.63753 6.12148 3.52992 6.20082 3.45058C6.28016 3.37123 6.38777 3.32666 6.49998 3.32666C6.61219 3.32666 6.7198 3.37123 6.79914 3.45058C6.87848 3.52992 6.92306 3.63753 6.92306 3.74974Z" fill="black" stroke="black" stroke-width="0.5"/>
                                                                </svg>
                                                                <span className="tooltip">{ activeTours[tour.tourId]['data']['tourInformation']['failedReason'] != null && activeTours[tour.tourId]['data']['tourInformation']['failedReason'] != "" ? activeTours[tour.tourId]['data']['tourInformation']['failedReason']: "Not Available"}</span>
                                                            </div>
                                                        }
                                                    </p>
                                                }
                                                {activeTours[tour.tourId]['data']['tourInformation']['creditCardStatus'] !=null &&
                                                    <p>
                                                        <strong className="container-lable-key">Credit Card Status:</strong> {activeTours[tour.tourId]['data']['tourInformation']['creditCardStatus']}
                                                    </p>
                                                }
                                                <p>
                                                    <strong className="container-lable-key">Excluded From Statistics:</strong> {activeTours[tour.tourId]['data']['prospect']['excludeFromStatistics'] ? 'YES': 'NO'}
                                                </p>
                                                {(activeTours[tour.tourId]['data']['tourInformation']['keyStatus'] !=null && activeTours[tour.tourId]['data']['tourInformation']['keyStatus'] !="") &&
                                                    <p>
                                                        <strong className="container-lable-key">Key Card Status:</strong> {activeTours[tour.tourId]['data']['tourInformation']['keyStatus']}
                                                    </p>
                                                }
                                                {activeTours[tour.tourId]['data']['history'].length>0 && <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                       {activeTours[tour.tourId]['data']['history'].length > 0 ? (
                                                            <div className="tour-history remove-border" style={fontSizeStyle}>
                                                                <p className='container-heading'>Tour History:</p>
                                                                {activeTours[tour.tourId]['data']['history'].map((h: any) => (
                                                                    <li key={h.timestamp}>
                                                                        <span>{h.timestamp}</span>
                                                                        <span>{h.location}</span>
                                                                    </li>
                                                                ))}
                                                            </div>
                                                        ) : null}
                                                    </div>}
                                                <TourAccessInformation
                                                    externalStyle={"remove-border"}
                                                    headingStyle={"container-heading"}
                                                    accessCodes={activeTours[tour.tourId]['data']['accessCodes']}
                                                    prospectFacingText={false}
                                                    bmxAccessCodes={[]}
                                                />
                                                <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }} className="space-x-4 mt-4">
                                                    <Button
                                                            addlClassName="btn-primary"
                                                            text={
                                                                activeTours[tour.tourId]['data']['prospect']['excludeFromStatistics']
                                                                    ? 'Include in Statistics'
                                                                    : 'Exclude from Statistics'
                                                            }
                                                            onClick={()=>{
                                                                handleIncludeOrExclude(tour.tourId)
                                                            }}
                                                            disabled={viewRole}
                                                        />
                                                        <Button
                                                            addlClassName="btn-primary"
                                                            text={
                                                                 activeTours[tour.tourId]['data']['tourInformation']['applicationSubmitted']
                                                                    ? 'Unmark Applied'
                                                                    : 'Mark Applied'
                                                            }
                                                            onClick={async () => {
                                                                if (activeTours[tour.tourId]['data']['tourInformation']['tourGuid'] === undefined) {
                                                                    setErrorMessage('Prospect has no associated ID.');
                                                                    return;
                                                                }
                                                                setTourChangeLoading(true);
                                                                const result = await updateApplicationStatus(
                                                                    activeTours[tour.tourId]['data']['tourInformation']['tourGuid'],
                                                                    !activeTours[tour.tourId]['data']['tourInformation']['applicationSubmitted']
                                                                );
                                                                if (result.success) {
                                                                    activeTours[tour.tourId]['data']['tourInformation']['applicationSubmitted'] = !activeTours[tour.tourId]['data']['tourInformation']['applicationSubmitted']
                                                                    closePopup();
                                                                } else if (result.error) {
                                                                    setErrorMessage(result.error);
                                                                }
                                                                setTourChangeLoading(false);
                                                            }}
                                                            disabled={viewRole}
                                                        />
                                                    {activeTours[tour.tourId]['data']['tourInformation']['tourStatus'] === TourStatuses.NoShow  && (
                                                        <Button
                                                            addlClassName="btn-primary"
                                                            text="Mark Tour Completed"
                                                            onClick={async () => {
                                                                setTourChangeLoading(true);
                                                                 if (activeTours[tour.tourId]['data']['prospect']['guestCardGuid'] === undefined) {
                                                                    setErrorMessage('Prospect has no associated ID.');
                                                                    setTourChangeLoading(false);
                                                                    return;
                                                                }

                                                                let completeResult = await markTourCompleted(activeTours[tour.tourId]['data']['prospect']['guestCardGuid']);

                                                                if (completeResult.success) {
                                                                    activeTours[tour.tourId]['data']['tourInformation']['tourStatus'] = TourStatuses.Complete;
                                                                    
                                                                    closePopup();
                                                                } else if (completeResult.error) {
                                                                    setErrorMessage(completeResult.error);
                                                                }
                                                                setTourChangeLoading(false);
                                                            }}
                                                            disabled={viewRole}
                                                        />
                                                    )}
                                                </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) :  
                                ( viewType === RecentActivityViewType.GuestCardOnly && tour.tourId == null ? <div className="border rounded shadow p-2 mb-2">
                                {/* Header Section */}
                                <div
                                    onClick={() => toggleGuestCardDropdown(tour.guestCardId)}
                                    style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', cursor: 'pointer' }}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
                                        <p className='container-head-text' >{tour.propertyName}</p>
                                        { tour.dateAndTime !=null && <p style={{ margin: '0px' }}>{moment(tour.dateAndTime).format("MM/DD/YYYY h:mm A")}</p>}
                                    </div>
                                    <span>
                                        {activeGuestCards[tour.guestCardId]!=null && activeGuestCards[tour.guestCardId]['viewType'] ? '▲' : '▼'}
                                    </span>
                                </div>
                                {activeGuestCards[tour.guestCardId]!=null &&  activeGuestCards[tour.guestCardId]['viewType'] && (
                                    <div className="mt-2">
                                        <p className='container-sub-tile' >{activeGuestCards[tour.guestCardId]['data']['tourStatus']}</p>
                                        {activeGuestCards[tour.guestCardId]['data']['contactPreference'] !=null &&  <p>
                                              <strong className="container-lable-key">Contact Preference:</strong> {activeGuestCards[tour.guestCardId]['data']['contactPreference']}
                                        </p>}
                                        {activeGuestCards[tour.guestCardId]['data']['desiredMoveInDate'] !=null &&  <p>
                                              <strong className="container-lable-key">Desired Move-In Date:</strong> {moment(activeGuestCards[tour.guestCardId]['data']['desiredMoveInDate']).format("MM/DD/YYYY")}
                                        </p>}
                                        {activeGuestCards[tour.guestCardId]['data']['pets'] !=null && <p>
                                              <strong className="container-lable-key">Pets:  </strong> {activeGuestCards[tour.guestCardId]['data']['pets'] ? 'Allowed' : 'No Pets'}
                                        </p>}
                                        {activeGuestCards[tour.guestCardId]['data']['source'] !=null && <p>
                                                <strong className="container-lable-key">Source:</strong> {activeGuestCards[tour.guestCardId]['data']['source']}
                                        </p>}
                                        {activeGuestCards[tour.guestCardId]['data']['desiredLeaseLength'] !=null && <p>
                                                <strong className="container-lable-key">Desired Lease Length:</strong> {activeGuestCards[tour.guestCardId]['data']['desiredLeaseLength']}
                                            </p>}
                                        {activeGuestCards[tour.guestCardId]['data']['idCheckStatus'] !=null &&
                                            <p>
                                                <strong className="container-lable-key">ID Check Status:</strong> {activeGuestCards[tour.guestCardId]['data']['idCheckStatus']}
                                                {  activeGuestCards[tour.guestCardId]['data']['idCheckStatus'] === "Failed" && 
                                                    <div className="tooltip-container">
                                                        <svg style={{ verticalAlign: 'middle', marginLeft: '6px' }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6.07692 5.65385H6.5V9.46154H6.92308M12 6.5C12 7.95869 11.4205 9.35764 10.3891 10.3891C9.35764 11.4205 7.95869 12 6.5 12C5.04131 12 3.64236 11.4205 2.61091 10.3891C1.57946 9.35764 1 7.95869 1 6.5C1 5.04131 1.57946 3.64236 2.61091 2.61091C3.64236 1.57946 5.04131 1 6.5 1C7.95869 1 9.35764 1.57946 10.3891 2.61091C11.4205 3.64236 12 5.04131 12 6.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M6.92306 3.74974C6.92306 3.86194 6.87848 3.96956 6.79914 4.0489C6.7198 4.12824 6.61219 4.17281 6.49998 4.17281C6.38777 4.17281 6.28016 4.12824 6.20082 4.0489C6.12148 3.96956 6.0769 3.86194 6.0769 3.74974C6.0769 3.63753 6.12148 3.52992 6.20082 3.45058C6.28016 3.37123 6.38777 3.32666 6.49998 3.32666C6.61219 3.32666 6.7198 3.37123 6.79914 3.45058C6.87848 3.52992 6.92306 3.63753 6.92306 3.74974Z" fill="black" stroke="black" stroke-width="0.5"/>
                                                        </svg>
                                                        <span className="tooltip">{activeGuestCards[tour.guestCardId]['data']['failedReason'] != null && activeGuestCards[tour.guestCardId]['data']['failedReason'] != ""? activeGuestCards[tour.guestCardId]['data']['failedReason']:"Not Available"}</span>
                                                    </div>
                                                }
                                            </p>    
                                        }
                                        {activeGuestCards[tour.guestCardId]['data']['creditCardStatus'] !=null && <p>
                                                <strong className="container-lable-key">Credit Card Status:</strong> {activeGuestCards[tour.guestCardId]['data']['creditCardStatus']}
                                            </p>}
                                        <p>
                                            <strong className="container-lable-key">Excluded From Statistics:</strong> {activeGuestCards[tour.guestCardId]['data']['excludeFromStatistics']? 'YES': 'NO'}
                                        </p> 
                                        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                                           {userIsSystemAdmin() && ( <Button
                                                                    addlClassName="btn-primary"
                                                                    text={
                                                                        activeGuestCards[tour.guestCardId]['data']['excludeFromStatistics']
                                                                            ? 'Include in Statistics'
                                                                            : 'Exclude from Statistics'
                                                                    }
                                                                    onClick={()=>
                                                                        handleIncludeOrExcludeGuestCard(tour.guestCardId)
                                                                    }
                                                                    disabled={viewRole}
                                                                /> )}
                                            { activeGuestCards[tour.guestCardId]['data']['publicKey']!=null ? (
                                                        <Button
                                                            addlClassName="btn-primary email-button"
                                                            text={
                                                                messageSent
                                                                    ? 'Sent!'
                                                                    : isSending
                                                                        ? 'Sending...'
                                                                        : 'Send Tour Signup Email'
                                                            }
                                                            onClick={() =>
                                                                postAction({
                                                                    setIsInProgress: setIsSending,
                                                                    setActionComplete: setMessageSent,
                                                                    setErrorMessage: setErrorMessage,
                                                                    action: () => sendTourSignupEmail(activeGuestCards[tour.guestCardId]['data']['publicKey'] as string)
                                                                    // we're already checking above that prospect.publicKey is not undefined
                                                                })
                                                            }
                                                            disabled={viewRole}
                                                        />
                                            ) : <></>
                                            }
                                        </div>
                                    </div>)
                                }
                            </div> : <></> ))
                            }
                        </div>
                    </>
                )}
                <FormValidationDisplay errorMessage={errorMessage} />
            </ModalBody>
        </Modal>
        <BlockProspectModal isOpen={openBlockProspect} prospect={prospect} onClose={function (): void {
                setBlockProspect(false);
            } } onBlock={function (reason: string): void {
                setBanReason(reason);
                setBlockProspect(false);
            } } prospectUserId={prospectToken} propertyId={propertyId} ></BlockProspectModal>
        </>
        
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/dashboardProspectPopup.tsx